import config from '../config'

const TokenService = {
  saveAuthToken(token) {
    window.localStorage.setItem(config.TOKEN_KEY, token)
  },
  saveUserId(userId) {
    window.localStorage.setItem(config.USER_ID, userId)
  },
  getUserId() {
    return window.localStorage.getItem(config.USER_ID)
  },
  getUserName() {
    return window.localStorage.getItem(config.USER_ID)
  },
  getAuthToken() {
    return window.localStorage.getItem(config.TOKEN_KEY)
  },
  clearAuthToken() {
    window.localStorage.removeItem(config.TOKEN_KEY)
  },
  clearUserId() {
    window.localStorage.removeItem(config.USER_ID)
  },
  hasAuthToken() {
    return !!TokenService.getAuthToken()
  },
  makeBasicAuthToken(userName, password) {
    return window.btoa(`${userName}:${password}`)
  },
}

export default TokenService
